import { AnyAction } from 'redux';

export enum LoginActionTypes {
  SIGNUP = 'AUTH/SIGNUP',
  SIGNIN = 'AUTH/SIGNIN',
  SIGNIN_SUCCESS = 'AUTH/SIGNIN_SUCCESS',
  SIGNIN_FAILED = 'AUTH/SIGNIN_FAILED',
  SIGNUP_SUCCESS = 'AUTH/SIGNUP_SUCCESS',
  SIGNUP_FAILED = 'AUTH/SIGNUP_FAILED',
  SIGNUP_REQUEST = 'AUTH/SIGNUP',
  CONFIRM_SIGNUP = 'AUTH/CONFIRM_SIGNUP',
  CONFIRM_SIGNUP_SUCCESS = 'AUTH/CONFIRM_SIGNUP_SUCCESS',
  CONFIRM_SIGNUP_FAILED = 'AUTH/CONFIRM_SIGNUP_FAILED',
  FORGOT_PASSWORD = 'AUTH/FORGOT_PASSWORD',
  FORGOT_PASSWORD_SUCCEEDED = 'AUTH/FORGOT_PASSWORD_SUCCEEDED',
  FORGOT_PASSWORD_FAILED = 'AUTH/FORGOT_PASSWORD_FAILED',
  SET_SIGNUP_EMAIL = 'AUTH/SET_SIGNUP_EMAIL',
  SET_FORGOT_PASSWORD_EMAIL = 'AUTH/SET_FORGOT_PASSWORD_EMAIL',
  RESET_SIGNIN_ERROR = 'AUTH/RESET_SIGNIN_ERROR',
  CONFIRM_PASSWORD = 'AUTH/CONFIRM_PASSWORD',
  CONFIRM_PASSWORD_SUCCESS = 'AUTH/CONFIRM_PASSWORD_SUCCESS',
  CONFIRM_PASSWORD_FAILED = 'AUTH/CONFIRM_PASSWORD_FAILED',
  SIGNOUT = 'AUTH/SIGNOUT',
  SIGNOUT_SUCCESS = 'AUTH/SIGNOUT_SUCCESS',
  SIGNOUT_FAILED = 'AUTH/SIGNOUT_FAILED',
  RESTORE_SESSION = 'AUTH/RESTORE_SESSION'
}

export interface SignInRequestAction extends AnyAction {
  type: LoginActionTypes.SIGNIN;
  username: string;
  password: string;
}

export const resetSignInError = () => ({
  type: LoginActionTypes.RESET_SIGNIN_ERROR,
});

export const signInRequest = (username: string, password: string): SignInRequestAction => ({
  type: LoginActionTypes.SIGNIN,
  username,
  password,
});

export const signInSucceeded = (user: any) => ({
  type: LoginActionTypes.SIGNIN_SUCCESS,
  payload: user,
});

export const signInFailed = (error: string): AnyAction => ({
  type: LoginActionTypes.SIGNIN_FAILED,
  error,
});

export interface SignUpRequestAction extends AnyAction {
  type: LoginActionTypes.SIGNUP;
  username: string;
  password: string;
}
export const signUpRequest = (username: string, password: string): SignUpRequestAction => ({
  type: LoginActionTypes.SIGNUP,
  username,
  password,
});
export const signUpSucceeded = (): AnyAction => ({ type: LoginActionTypes.SIGNUP_SUCCESS });
export const signUpFailed = (error: string): AnyAction => ({ type: LoginActionTypes.SIGNUP_FAILED, error });

export interface ConfirmSignUpAction extends AnyAction {
  type: LoginActionTypes.CONFIRM_SIGNUP;
  username: string;
  code: string;
}
export const confirmSignUpRequest = (username: string, code: string): ConfirmSignUpAction => ({
  type: LoginActionTypes.CONFIRM_SIGNUP,
  username,
  code,
});
export const confirmSignUpSuccess = (): AnyAction => ({ type: LoginActionTypes.CONFIRM_SIGNUP_SUCCESS });
export const confirmSignUpFailed = (error: string): AnyAction => ({
  type: LoginActionTypes.CONFIRM_SIGNUP_FAILED,
  error,
});

export interface ForgotPasswordRequestAction extends AnyAction {
  type: LoginActionTypes.FORGOT_PASSWORD;
  username: string;
}

export const forgotPasswordRequest = (email: string): ForgotPasswordRequestAction => ({
  type: LoginActionTypes.FORGOT_PASSWORD,
  username: email,
});

export const forgotPasswordSucceeded = (email: string) => ({
  type: LoginActionTypes.FORGOT_PASSWORD_SUCCEEDED,
  payload: email,
});

export const forgotPasswordFailed = (error: string): AnyAction => ({
  type: LoginActionTypes.FORGOT_PASSWORD_FAILED,
  error,
});

export interface SetForgotPasswordEmailAction extends AnyAction {
  type: LoginActionTypes.SET_FORGOT_PASSWORD_EMAIL;
  payload: string;
}

export const setForgotPasswordEmailAction = (
  email: string
): SetForgotPasswordEmailAction => ({
  type: LoginActionTypes.SET_FORGOT_PASSWORD_EMAIL,
  payload: email,
});

export interface RestoreSessionAction {
  type: LoginActionTypes.RESTORE_SESSION;
  payload: {
    user: {
      email: string;
    };
  };
}

export const restoreSessionAction = (
  user: { email: string }
): RestoreSessionAction => ({
  type: LoginActionTypes.RESTORE_SESSION,
  payload: { user },
});

export interface SetSignUpEmailAction extends AnyAction {
  type: LoginActionTypes.SET_SIGNUP_EMAIL;
  payload: string;
}

export const setSignUpEmailAction = (email: string): SetSignUpEmailAction => ({
  type: LoginActionTypes.SET_SIGNUP_EMAIL,
  payload: email, 
});

export const resetSignInErrorAction = (error?: string): AnyAction => ({
  type: LoginActionTypes.RESET_SIGNIN_ERROR,
  error: error ?? null,
});

export interface ConfirmPasswordRequestAction extends AnyAction {
  type: LoginActionTypes.CONFIRM_PASSWORD;
  username: string;
  verificationCode: string;
  newPassword: string;
}
export const confirmPasswordRequest = (
  username: string,
  verificationCode: string,
  newPassword: string,
): ConfirmPasswordRequestAction => ({
  type: LoginActionTypes.CONFIRM_PASSWORD,
  username,
  verificationCode,
  newPassword,
});
export const confirmPasswordSucceeded = (): AnyAction => ({ type: LoginActionTypes.CONFIRM_PASSWORD_SUCCESS });
export const confirmPasswordFailed = (error: string): AnyAction => ({
  type: LoginActionTypes.CONFIRM_PASSWORD_FAILED,
  error,
});
export const signOutRequest = (): AnyAction => ({ type: LoginActionTypes.SIGNOUT });
export const signOutSucceeded = (): AnyAction => ({ type: LoginActionTypes.SIGNOUT_SUCCESS });
export const signOutFailed = (error: string): AnyAction => ({ type: LoginActionTypes.SIGNOUT_FAILED, error });
